export default [
    {
        path: '/juncao',
        name: 'juncao-index',
        component: () => import('./views/Index.vue'),
        meta: {
            title: 'Gerar Junções',
            icon: 'mdi-source-merge',
            breadcrumbs: [
                { text: 'Oferta', disabled: true, href: '/' },
                { text: 'Gerar Junções', disabled: true, href: '/' }
            ]
        }
    }
]
